const CurriculumMapsPolicy = {
  /**  Since backend is returning same id for multiple objects of
   * LearningCourseCurriculumMapEdge, we are disabling its normalization */
  LearningCourseCurriculumMapEdge: {
    keyFields: false,
  },
};

export default CurriculumMapsPolicy;
